import type { DynamicHelpConfig } from './dynamicHelp.types';

export const dynamicHelp: DynamicHelpConfig = {
  labelMessageKey: 'forms.type.subject.label',
  items: [],
};
